class LocalStorageService {
  private static readonly NONCE_KEY:string = 'quiz_nonce';
  private static readonly QWID_KEY:string = 'qwid';

  public static setNonce(quizNameSlug:string, nonce:string) {
    localStorage.setItem(`${quizNameSlug}_${this.NONCE_KEY}`, nonce);
  }

  public static setQwid(qwid:string) {
    localStorage.setItem(this.QWID_KEY, qwid);
  }

  public static getNonce(quizNameSlug:string):string | null {
    return localStorage.getItem(`${quizNameSlug}_${this.NONCE_KEY}`) || null;
  }

  public static getQwid():string | null {
    return localStorage.getItem(this.QWID_KEY) || null;
  }

  public static clearStorage(quizNameSlug:string){
    localStorage.removeItem(`${quizNameSlug}_${this.NONCE_KEY}`);
    localStorage.removeItem(this.QWID_KEY);
  }
}

export default LocalStorageService;